import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AffiliateConfigService {

	affiliateToken: string = '';
	config: Record<string, any> | null = null;

	load(): Promise<void> {

		const promise = (window as any).__affiliateConfigPromise as Promise<Record<string, any> | null> | undefined;

		if( ! promise ) {

			return Promise.resolve();
		}

		return promise.then( data => {

			if( ! data ) return;

			const token = new URLSearchParams( window.location.search ).get( 'aftoken' ) ?? '';

			if( token && data[token] ) {

				this.affiliateToken = token;
				this.config = data[token];
			}
		} );
	}

	get isAffiliateMode(): boolean {

		return this.affiliateToken.length > 0;
	}
}
